module.exports = __webpack_public_path__ + "img/BCG_2011_2.73807ca4.png";